import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { CloseIcon } from './AppIcons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      //  position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    dialogPaper: {
      display: 'grid',
      overflow: 'hidden',
      gridTemplateRows: 'auto minmax(0, 100%)',
      maxHeight: '80vh',
      minHeight: '80vh',
    },
    fullPaper: {
      display: 'grid',
      overflow: 'hidden',
      gridTemplateRows: 'auto minmax(0, 100%)',
    }
  }),
);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function FullScreenDialog({ handleClose, title, open, fullScreen, children }: any) {
  const classes = useStyles();

  var paper = fullScreen === false ? { paper: classes.dialogPaper } : { paper: classes.fullPaper };

  return (
    <div>
      <Dialog
        classes={paper}
        fullScreen={fullScreen}
        maxWidth={'sm'}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar} position="static">
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              OK
                        </Button>
          </Toolbar>
        </AppBar>
        {children}

      </Dialog>
    </div>
  );
}
